// extracted by mini-css-extract-plugin
export default {"wrapper":"GA","subscription":"HA","select_item":"IA","is_selected":"JA","otb":"KA","radio":"LA","first_row":"MA","prices":"NA","italic":"OA","info_wrapper":"PA","first_month":"QA","separator":"RA","checkmark":"SA","bullets":"TA","bullet":"UA","checkmarkText":"VA","button":"WA","discountBadge":"XA"};
    if(module.hot) {
      // 1713361650641
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  